<template>
  <app-side-menu :min-width="18"
    :fixed-menu="false">
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">  Sub Job Stage: {{ entityName }} </span>
      </p>
      <ul class="menu-list">
        <li>
          <router-link
            :to="{ name: routeTypes.SubJobStageDetail.name, params: { subJobStageId: $route.params.subJobStageId }, query: $route.query }"
            active-class="is-active"
            exact
          >
            <span
              :class="{ 'has-badge-danger has-badge-small has-badge-rounded has-badge-offset2': $v.detailGroup.$error }"
              :data-badge="$v.detailGroup.$error ? '' : null"
            >
              Detail Info
            </span>
          </router-link>
        </li>
      </ul>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import SubJobStageRoutes from './route-types'

export default {
  name: 'SubJobStageSideMenu',
  inject: ['$vv'], //validation
  components: {
    AppSideMenu
  },
  props: {
    entityName: {
      type: String,
      default: ''
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    routeTypes() {
      return SubJobStageRoutes
    }
  },
  mounted() {},
  methods: {}
}
</script>